class Locale {
  static DEFAULT = Locale.create("ru-RU");
  static current = Locale.DEFAULT;

  constructor(language, countryCode = null) {
    this.language = language;
    this.countryCode = countryCode;
  }

  static create(str) {
    const parts = (str || "").split("-");
    return new Locale(parts[0], parts[1]);
  }

  static setLocale(locale) {
    if (locale instanceof Locale) {
      Locale.current = locale;
    } else {
      Locale.current = Locale.create(locale);
    }
  }

  toLocalString(sep = "-") {
    return `${this.language}${sep}${this.countryCode}`;
  }

  toString() {
    return `${this.language}-${this.countryCode}`
  }
}

export default Locale;
